import { SelectChangeEvent } from '@mui/material'

export function changeStorageSampleSelection(
  field: string,
  e: SelectChangeEvent,
  sampleIndex: number,
  setAnimals: any,
  uai: number,
) {
  // STU-1815 ...automatically select the same values on all remaining animals (and any subsequently added samples)
  if (sampleIndex === 0) {
    setAnimals((a: any) => {
      const newUAIsamples = a[uai]
      // update current sample
      newUAIsamples.splice(sampleIndex, 1, {
        ...a[uai][sampleIndex],
        metadata: {
          ...a[uai][sampleIndex]?.metadata,
          [field]: e.target.value,
        },
      })
      // reflect change on all other non-entered samples
      newUAIsamples.forEach((s: any, index: number) => {
        if (!s?.metadata?.[field]) {
          newUAIsamples[index].metadata = {
            ...newUAIsamples[index]?.metadata,
            [field]: e.target.value,
          }
        }
      })
      return {
        ...a,
        [uai]: newUAIsamples,
      }
    })
  } else {
    setAnimals((a: any) => {
      const newUAIsamples = a[uai]
      newUAIsamples.splice(sampleIndex, 1, {
        ...a[uai][sampleIndex],
        metadata: {
          ...a[uai][sampleIndex]?.metadata,
          [field]: e.target.value,
        },
      })
      return {
        ...a,
        [uai]: newUAIsamples,
      }
    })
  }
}
